import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PayGateInitModel } from '../../models/payGate';
import { AppConfig } from './../../config/app-config';
import { FileSection, FileType } from './../../models/fileData';
import { EnquiriesService } from './../../services/enquiries.service';
import { TenderService } from './../../services/tender.service';

@Component({
  selector: 'app-tender-download',
  templateUrl: './tender-download.component.html'
})

export class TenderDownloadComponent implements OnInit {
  TenderForm$: FormGroup;
  payForm: FormGroup;

  Tender$: any = {
    'id': 0,
    'title': '',
    'description': '',
    'disclaimer': '',
    'websiteListingStartDate': null,
    'websiteListingEndDate': null,
  };

  TenderDisclaimer$: any = {
    'id': 0,
    'disclaimer': ''
  }
  TenderDocumentsList$: any[] = [];

  ResultMessage$ = '';
  DownloadId$ = '';

  submitted: boolean = false;
  pageErrors: boolean = false;

  pgInit: PayGateInitModel;
  payGateID = '';
  pgReference = '';
  pgAmount = '';
  pgDate = '';
  pgReturnUrl = '';
  pgEmail = '';
  pgChecksum = '';
  currentTenderId = 0;

  captchaInvalid: boolean = true;

  @ViewChild('payFormEl', null) payFormElement;

  constructor(
    private tenderService: TenderService,
    private route: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private enquiriesService: EnquiriesService,
    private appConfig: AppConfig,
    private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.TenderForm$ = this.formBuilder.group({
      id: [0, Validators.required],
      firstName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      lastName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      companyName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      contactPersonCell: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      //contactPersonEmail: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350), Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")])],
      contactPersonEmail: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,9}$")])],
      documentId: [0, Validators.required],
      agreeDisclaimer: [false, Validators.requiredTrue],
      recaptchaReactive: null
    });

  }

  ngAfterContentInit() {
    this.loadTender();
  }

  get f() { return this.TenderForm$.controls; }

 loadTender() {
    this.route.queryParams.subscribe((params) => {
      let tenderId = +params['tenderId'];
      this.currentTenderId = tenderId;
      this.tenderService.getTenderArticle(tenderId).subscribe(async (response) => {
        this.Tender$ = response;
        this.Tender$.description = this.sanitizer.bypassSecurityTrustHtml(response.description);
        if (this.Tender$.disclaimer == "" || this.Tender$.disclaimer == null) {
          await this.tenderService.getTenderDisclaimer().subscribe((GlobalDisclaimer) => {
            this.TenderDisclaimer$ = GlobalDisclaimer;
            this.Tender$.disclaimer = this.TenderDisclaimer$.disclaimer;
          });
        }
      }, (error) => {
        console.log(error);
      });

    });
  }

  resolved(captchaResponse: string) {

    if (captchaResponse == null) {
      this.captchaInvalid = true;
    }
    else {
      this.captchaInvalid = false;
    }
  }

  sendEnquiry() {

    this.ResultMessage$ = "Submitting, please wait...";
    //console.log(this.Tender$);
    this.submitted = true;
    this.pageErrors = false;

    if (this.TenderForm$.invalid) {
      this.pageErrors = true;
      this.ResultMessage$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid == true) {
      this.pageErrors = true;
      this.ResultMessage$ = "Please complete the captcha";
      return;
    }

    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "SectionId": 5,
      "DateAdded": currentDate,
      "EnquiryProperties": []
    };

    //this.DownloadId$ = this.GenerateGuid();
    enquiry.EnquiryProperties.push({ "key": "firstName", "value": this.TenderForm$.controls.firstName.value });
    enquiry.EnquiryProperties.push({ "key": "lastName", "value": this.TenderForm$.controls.lastName.value });
    enquiry.EnquiryProperties.push({ "key": "companyName", "value": this.TenderForm$.controls.companyName.value });
    enquiry.EnquiryProperties.push({ "key": "contactPersonCell", "value": this.TenderForm$.controls.contactPersonCell.value });
    enquiry.EnquiryProperties.push({ "key": "contactPersonEmail", "value": this.TenderForm$.controls.contactPersonEmail.value });
    enquiry.EnquiryProperties.push({ "key": "documentId", "value": this.Tender$.id.toString() });
    enquiry.EnquiryProperties.push({ "key": "subject", "value": "Tender Download" });

    if (this.Tender$.price > 0) {
      enquiry.EnquiryProperties.push({ "key": "paymentStatus", "value": "0" });
      enquiry.EnquiryProperties.push({ "key": "price", "value": this.Tender$.price.toString() });

      var init: any = {
        tenderId: this.currentTenderId,
        email: this.TenderForm$.controls.contactPersonEmail.value,
        name: this.TenderForm$.controls.lastName.value
      }
      console.log(init);
      this.tenderService.initTenderPayment(init).subscribe((response) => {

        console.log(response);

        this.payGateID = response.payGateId;
        this.pgReference = response.reference;
        this.pgAmount = response.amount;
        this.pgDate = response.date;
        this.pgReturnUrl = response.returnUrl;
        this.pgEmail = init.email;
        this.pgChecksum = response.checksum;
        var payElem = this.payFormElement;

        enquiry.EnquiryProperties.push({ "key": "paymentReference", "value": response.reference });
        console.log(enquiry);
        this.enquiriesService.saveEnquiry(enquiry).subscribe((enqResponse) => {
          console.log("saved enquiry");
          console.log(enqResponse);
          setTimeout(function () {
            console.log(payElem);
            payElem.nativeElement.submit();
            //debugger;
          }, 50);
          this.ResultMessage$ = "";
        }, (error) => {
          this.ResultMessage$ = "An error occurred. Please try again later.";
          console.error(error);
        })


      }, (error) => {
        console.error(error);
      });
    }
    else {
      this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {
        this.listDocuments(this.Tender$.id);
        this.ResultMessage$ = "";
      }, (error) => {
        this.ResultMessage$ = "An error occurred. Please try again later.";
        console.error(error);
      })
    }


    //this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {

    //  if (this.Tender$.price > 0) {
    //    /*this.PaymentPage();*/
    //  }
    //  else {
    //    this.listDocuments(this.Tender$.id);
    //  }
    //  this.ResultMessage$ = "";
    //  //this.ResultMessage$ = "You can now download the documents below.";
    //}, (error) => {
    //  this.ResultMessage$ = "An error occurred. Please try again later.";
    //  console.log(error);
    //})
  }

  GenerateGuid() {
    var dashPos = 9;
    var sGuid = "";
    for (var i = 0; i < 32; i++) {
      if (i == dashPos && i <= 20) {
        sGuid += "-";
        dashPos += 4;
      }

      sGuid += Math.floor(Math.random() * 0xF).toString(0xF);
    }
    return sGuid;
  }

  listDocuments(tenderId: number) {
    this.tenderService.getFilesList(tenderId).subscribe((response) => {
      this.TenderDocumentsList$ = response as any[];
    }, (error) => {
      console.log(error);
    });
  }

  downloadDocument(documentId: number) {

    let linkedId = this.Tender$.id;

    var fileInfo = this.tenderService.getFileInfo(linkedId).subscribe((response) => {

      var fileInfo = response.find(x => x.id == documentId);

      fileInfo.fileLocation = this.appConfig.baseUrl + '/Uploads/' + FileSection[fileInfo.fileSection] + '/' + FileType[fileInfo.fileType] + '/' + fileInfo.linkedId + '/' + fileInfo.physicalFileName;

      this.tenderService.downloadFile(fileInfo.fileLocation).subscribe((fileResponse) => {

        // file-type
        let fileName = fileInfo.displayFileName;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(fileResponse.body);

        window.open(link.href, "_blank");

        //link.download = fileName;
        //link.click();
      }, (error) => {
        console.log(error);
      });

      return fileInfo;
    }, (error) => {
      console.log(error);
    });
  }

  submitPayment() {
    console.log("submitting payment");

    var init: any = {
      tenderId: this.currentTenderId,
      email: "jaycen@purplecosmos.co.za",
      name: "Dale"
    }

    console.log(init);
    this.tenderService.initTenderPayment(init).subscribe((response) => {

      console.log(response);

      this.payGateID = response.payGateId;
      this.pgReference = response.reference;
      this.pgAmount = response.amount;
      this.pgDate = response.date;
      this.pgReturnUrl = response.returnUrl;
      this.pgEmail = 'jaycen@purplecosmos.co.za';
      this.pgChecksum = response.checksum;
      var payElem = this.payFormElement;
      setTimeout(function () {
        console.log(payElem);
        payElem.nativeElement.submit();
        //debugger;
      }, 50);
    }, (error) => {
      console.error(error);
    });


    // DO NOT DELETE

    //this.setPaymentForm();
    //var payElem = this.payFormElement;
    //setTimeout(function () {
    //  console.log(payElem);
    //  payElem.nativeElement.submit();
    //  debugger;
    //}, 50);

  }
}
